var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollview",attrs:{"id":"app"}},[_c('header-bar'),_c('router-view',{staticClass:"router-view"}),(_vm.$route.path!='/login'&&_vm.$route.path!='/register'&&_vm.$route.path!='/forgetPwd')?_c('second-footer'):_vm._e(),_c('footer-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }